import type { DialogueKwPaymentCardMessage } from 'components/Dialogue/types';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { memo } from 'react';
import styled from '@emotion/styled';
import SafeImage from 'components/SafeImage';
import { Divider } from 'antd';
import { useTranslate } from '@tolgee/react';
import EnhanceText from 'components/Dialogue/components/Message/EnhanceText';

export const KwPaymentRemindMsg = memo((props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;
  const { t } = useTranslate();
  const { clickQuote } = useChatContext();
  const {
    body: {
      title,
      contentItem: [
        { paymentContent: { itemTitle, itemImageUrl, itemCount, payPrice } = {} } = {},
      ] = [],
      afterContentDesc,
    },
  } = (msg as DialogueKwPaymentCardMessage).content;
  const { topBarInfo } = conversation;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <QuoteMessage
          message={raw}
          storeName={topBarInfo?.storeName}
          wrap
          onQuoteClick={clickQuote}
        >
          <Container>
            <header>
              <EnhanceText text={title} platform="KWAI" />
            </header>
            <div>
              <SafeImage width={56} height={56} src={itemImageUrl} />
              <section>
                <h4>{itemTitle}</h4>
                <div>
                  <span>{`${t('domain.order.payment.field.totalAmount')} ${payPrice}`}</span>
                  <Divider type="vertical" />
                  <span>{`${itemCount} ${t('domain.product.field.product')}`}</span>
                </div>
              </section>
            </div>
            <footer>
              <EnhanceText text={afterContentDesc} platform="KWAI" />
            </footer>
          </Container>
        </QuoteMessage>
      }
    />
  );
});

const Container = styled.div`
  width: 390px;
  max-width: 100%;
  padding: 6px;
  background: #fff;
  border-radius: 2px;
  > header {
    margin-bottom: 6px;
    line-height: 20px;
    color: #515359;
  }
  > div {
    display: flex;
    > div {
      flex: 0 0 auto;
      margin-right: 8px;
    }
    > section {
      flex: 1 0 0;
      overflow: hidden;
      > h4 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      > div {
        font-size: 12px;
        > span {
          color: #84868c;
        }
      }
    }
  }
  > footer {
    margin-top: 6px;
    line-height: 18px;
    font-size: 12px;
    color: #84868c;
  }
`;
